/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).on("turbo:load", () => new App.tedDiscussions())

window.App.tedDiscussions = class tedDiscussions {
  constructor() {
    this.$rootEl = $("#discuss")
    this.bindElements()
    if ($(".responses").is(":visible")) {
      this.openDiscussion()
    }
  }

  bindElements() {
    $(document).on("ready.discussions", e => {
      return this.bindAutoHeight()
    })

    $(document).on("click.discussions", ".uiToggleSwitch a", e => {
      return this.togglePanels(e)
    })

    return $(document).on(
      "click.discussions",
      ".save-discussion",
      function (e) {
        e.preventDefault
        $(this).fadeOut(300)
        return $("#discuss_panel .success").fadeIn(500).delay(1500).fadeOut(500)
      }
    )
  }

  togglePanels(e) {
    const panelName = $(e.target).data("panel")
    if (panelName === "discussion") {
      $("#panels").hide()
      $("#discuss").show()
      $("#discussToggleContent").show()
      $("#standardToggleContent .aboutLesson.non-mobile").hide()
      return this.openDiscussion()
    } else {
      $("#panels").show()
      $("#discuss").hide()
      $("#discussToggleContent").hide()
      return $("#standardToggleContent .aboutLesson.non-mobile").show()
    }
  }

  bindAutoHeight() {
    // Recalculate discussion panel height if the content is changed.
    if (this.$rootEl.length < 1) {
      return
    }

    const panelObserver = new MutationObserver(() => this.openDiscussion())
    return panelObserver.observe(this.$rootEl.get(0), {
      subtree: true,
      childList: true,
    })
  }

  // This function recalculates the height of the discussion panel and creates
  // a virtual scrollbox
  openDiscussion() {
    let subtract_height = 0
    const height_array = [
      $(".orator"),
      $(".oratorForm"),
      $(".discussHeader"),
      $(".oratorStart"),
    ]
    $.each(height_array, function (i, el) {
      if (el.is(":visible")) {
        return (subtract_height = subtract_height + el.height())
      }
    })
    let responseHeight = $("#sideRail").height() - subtract_height - 20
    if (responseHeight < 500) {
      responseHeight = 500
    }
    $(".responses").height(responseHeight)
    return $("#standardToggleContent .aboutLesson.non-mobile").hide()
  }
}
